<template>
  <div class="book">
    <div class="middle-main">
      <!-- <div @click="openOrder()">
        <column-title title="E-book PERVIEW" desc="我要訂閱" v-if="isPc == 1" />
      </div> -->
      <div :class="['magazine-details', { 'flex-row': isPc == 1 }]">
        <div class="magazine-details-left">
          <div class="magazine-swiper">
            <!-- <swiper :options="swiperOption3" ref="mySwiper">
              <swiper-slide v-for="item in detailsRes.image" :key="item">
                <div class="magazine-item justify-center items-center">
                  <img :src="item" />
                </div>
              </swiper-slide>
            </swiper> -->
            <el-carousel height="650px">
              <el-carousel-item v-for="item in detailsRes.image" :key="item">
                <div class="magazine-item ">
                  <img :src="item" />
                </div>
              </el-carousel-item>
            </el-carousel>
            <!-- <div
              class="swiper-button-prev3 items-center justify-center hand"
              v-if="isPc == 1"
            >
              <svg-icon icon-class="Path 707"></svg-icon>
            </div>
            <div
              class="swiper-button-next3 items-center justify-center hand"
              v-if="isPc == 1"
            >
              <svg-icon icon-class="Path 707"></svg-icon>
            </div> -->
          </div>

        </div>
        <div class="magazine-details-right flex-col">
          <!-- <h3><em>NO.</em>{{ detailsRes.title }}</h3> -->
          <p v-html="detailsRes.title"></p>
          <span class="sales">{{ L('已售') }} {{ detailsRes.soldOut ? detailsRes.soldOut : 0 }}</span>
          <h5>
            HK$ <em>{{ detailsRes.price }}</em>
            <!-- <button class="buy-paper-btn" @click="fnBuyMagazine">
              {{ L('订阅纸质版') }}
              <svg-icon icon-class="arrow-right" color="#fff"></svg-icon>
            </button> -->
          </h5>
          <div class="line"></div>

          <!-- <p></p> -->
          <div class="btns" v-if="!isBuy">
            <button v-if="!isInCart" @click="add" class="cart-btn">
              加入購物車
            </button>
            <button v-else @click="fnToCart" class="cart-btn">
              已加購，去購物車結算
            </button>
            <button @click="fnToBuy" class="buy-pdf-btn">
              購買电子版
              <svg-icon icon-class="pdf2" color="#fff"></svg-icon>
            </button>
            <!-- <button @click="fnToPreview">線上預覽</button> -->
          </div>
          <div class="btns" v-else>
            <button class="read-btn" @click="fnToPreview">立即閱讀</button>
          </div>

          <!-- <div class="shopcar-icon">
      <div class="num">3</div>
      <svg-icon class="font22" icon-class="cart-black"></svg-icon>
    </div> -->
          <!-- <button>年度訂閱</button> -->
          <!-- <span>產品編號: <b>00978956</b> </span>
          <span>庫存狀態: <b>尚有庫存</b> </span> -->
        </div>
      </div>
      <div v-if="isPc == 1" class="line"></div>

      <el-row :gutter="isPc == 1 ? 40 : 0">

        <el-col :span="isPc == 1 ? 19 : 24">
          <div class="magazine-details-content">
            <h2>{{ L('图书信息') }}</h2>
            <div class="book-info">
              <el-row>
                <el-col :span="isPc == 1 ? 12 : 24">
                  <div class="book-info-item">
                    <span>{{ L('ISBN版号') }}</span>
                    <span>{{ detailsRes.isbn }}</span>
                  </div>
                </el-col>
                <el-col :span="isPc == 1 ? 12 : 24">
                  <div class="book-info-item">
                    <span>{{ L('出版社名称') }}</span>
                    <span>{{ detailsRes.publisher }}</span>
                  </div>
                </el-col>
                <el-col :span="isPc == 1 ? 12 : 24">
                  <div class="book-info-item">
                    <span>{{ L('书名') }}</span>
                    <span>{{ detailsRes.title }}</span>
                  </div>
                </el-col>
                <el-col :span="isPc == 1 ? 12 : 24">
                  <div class="book-info-item">
                    <span>{{ L('图书册数') }}</span>
                    <span>{{ L('1册') }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div v-if="isPc == 1" class="line"></div>
            <!-- <h2>購買須知</h2>
            <div class="content" v-html="purchaseNotes"></div>
            <div class="line"></div> -->
            <h2>{{ L('图书详情') }}</h2>
            <div class="content" v-html="detailsRes.content"></div>
            <div class="comment-box">
          <div class="line" v-if="isPc != 3"></div>
          <!-- 添加评论 -->
          <Comment :newsId="detailsRes.mgzId" :type="3" />
        </div>
          </div>
        </el-col>
        <el-col :span="isPc == 1 ? 5 : 24" class="book-list-container" v-if="magazineListRes.length > 0">
          <h2>{{ L('猜你喜欢') }}</h2>
          <div class="book-list">
            <el-row :gutter="isPc == 1 ? 20 : 0">
              <el-col :span="isPc == 1 ? 24 : 12" v-for="item in magazineListRes" :key="item.mgzId">
                <div class="book-item hand" @click="toDetails(item.mgzId, item.url)">
                  <!-- <book-3d :image="item.image" /> -->
                  <img :src="item.image" />
                  <div class="book-info">
                    <p v-html="item.title" class="book-title"></p>
                    <div class="price-sales">
                      <span class="price">HK$ <em>{{ item.price }}</em></span>
                      <span class="sales">{{ L('已售') }} {{ item.soldOut ? item.soldOut : 0 }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import ColumnTitle from "../common/column-title.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import book3d from "../common/book-3d.vue";
import Comment from "../common/comment.vue";

import {
  getMagazineDetails,
  createOrder,
  addCart,
  checkInCart,
  checkInOrder,
  getMagazineList,
} from "@/assets/api/magazine.js";
import { getAboutInfo } from "@/assets/api/common.js";

export default {
  components: {
    swiper,
    swiperSlide,
    swiperPolicy,
    ColumnTitle,
    book3d,
    Comment
  },
  data() {
    return {
      swiperOption3: {
        slidesPerView: 1, //一页显示几个
        spaceBetween: 0, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next3", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev3", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled3", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden3", //按钮隐藏时的Class
        },
      },
      activeName: "first",
      detailsRes: {},
      purchaseNotes: "",
      startPoint: {},
      endPoint: {},
      isBuy: false, //是否购买过
      isInCart: false, //是否已经在购物车
      magazineListRes: [],
      adminList: ['1062150659@qq.com', '573580143@qq.com', 'fandouhao@gmail.com', 'ts960@vip.163.com'],
    };
  },
  watch: {
    $route() {
      this.$router.go();
    },
  },
  computed: {
    ...mapState(["isPc", "validToken", "userInfo"]),
  },
  created() {
    console.log('this.$route.params.id=====',this.$route.params.id)
    getMagazineDetails(this.$route.params.id).then((res) => {
      this.detailsRes = res.data.data;
      this.detailsRes.image = this.detailsRes.image.split(",");
      this.detailsRes.image = this.detailsRes.image.map((item) => {
        item = !/^http/.test(item) ? this.$imgUrl + item : item;
        return item;
      });
    });
    getAboutInfo("relatedByBuy").then((res) => {
      this.purchaseNotes = res.data.data.relatedContent;
    });
    checkInCart(this.$route.params.id).then((res) => {
      console.log("查询当前商品是否已加入购物车===", res.data);
      if (res.data.data != null) this.isInCart = true;
    });
    checkInOrder(this.$route.params.id).then((res) => {
      console.log("查询当前商品是否已购买过===", res.data);
      if (this.adminList.includes(this.userInfo.userName)) {
        this.isBuy = true
      } else {
        if (res.data.data != null) {
          this.isBuy = true;
        }
      }

    });
    const data = {
      orderByColumn: "tips",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 30,
      goodsTypeDict: 2,
    }
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    getMagazineList(formData).then((res) => {
      //随机取3本 
      this.magazineListRes = res.data.rows.filter((item) => item.mgzId != this.$route.params.id).sort(() => Math.random() - 0.5).slice(0, 3).map((item) => {
        item.image = item.image.split(",");
        item.image = item.image.map((it) => {
          it = !/^http/.test(it) ? this.$imgUrl + it : it;
          return it;
        });
        item.image = item.image[0];
        return item;
      });
    });
  },
  methods: {
    toDetails(id, url) {
      this.$router.push({
        path: `/book-details/${id}`,
      });
    },
    fnToPreview() {
      localStorage.setItem('bookId', this.$route.params.id)
      this.$router.push({
        path: `/book-preview`,
      });
    },
    fnToCart() {
      this.$router.push({
        path: `/magazine-cart`,
      });
    },
    fnToAddCart() {
      addCart(this.$route.params.id).then((res) => {
        if (res.data.code == 500) {
          console.log("請先登錄");
        } else {
          console.log(res);
        }
      });
    },
    // 加入购物车
    add(e) {
      addCart(this.$route.params.id).then((res) => {
        if (res.data.code == 500) {
          this.$store.state.isDialogVisible = true;
          console.log("請先登錄");
        } else {
          console.log(res);
          this.$message({
            message: "加購成功，請去購物車結算",
            type: "success",
          });
          this.$store.dispatch("getMyCart");
          // 特效
          // 页面滚动高度
          var scrolltopTemp =
            document.documentElement.scrollTop || document.body.scrollTop;
          // 获取起点
          this.startPoint.x = e.pageX;
          this.startPoint.y = e.pageY;
          // 获取终点
          let target = document.querySelector(".shopcar-icon");
          let targetParent = target.offsetParent;
          this.endPoint.y = targetParent.offsetTop + scrolltopTemp + 60;
          this.endPoint.x = targetParent.offsetLeft + target.offsetWidth / 2;
          console.log(this.startPoint);
          console.log(this.endPoint);
          // 插入div（ball）
          let ball = document.createElement("div");
          ball.className = "ball";
          ball.style.top = this.startPoint.y + "px";
          ball.style.left = this.startPoint.x + "px";
          document.body.appendChild(ball);
          // 添加动画属性
          setTimeout(() => {
            ball.style.top = this.endPoint.y + "px";
            ball.style.left = this.endPoint.x + "px";
          }, 0);
          // 动画结束后，删除自己
          ball.ontransitionend = function () {
            this.remove();
          };
        }
      });
    },
    fnToBuy() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/magazine-order/${this.$route.params.id}`,
        });
      }

      // createOrder(this.$route.params.id).then((res) => {
      // if (res.data.code == 500) {
      //   console.log("請先登錄");
      // } else {

      // window.open(res.data.data, "_blank");
      // window.open('https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=EC-0WU77850R1826910E', "_blank");

      //   console.log(res);
      // }
      // });
    },
    fnBuyMagazine() {
      this.$router.push({
        path: `/order-single/${this.$route.params.id}`,
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    openOrder() {
      this.$router.push({
        path: `/order`,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.book {
  .magazine-details {
    margin-top: 40px;

    .magazine-details-left {
      width: 500px;

      .magazine-swiper {
        width: 100%;
        position: relative;
      }

      .magazine-item {
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
          cursor: pointer;
        }
      }

      .content {
        padding: 40px 50px 40px 0;
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.19;
        letter-spacing: 0.8px;
        text-align: left;
        color: #000;
      }
    }

    .magazine-details-right {
      margin-left: 40px;
      flex: 1;
      position: relative;

      h3 {
        em {
          font-size: 10px;
          line-height: 14px;
          font-weight: bold;
        }

        width: fit-content;
        font-family: MicrosoftYaHei,
        MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #E2291E;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-bottom: 4px;
        border-bottom: 4px solid #E2291E;
        margin-bottom: 12px;
      }

      span {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #AEAEB2;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        margin-top: 12px;
        margin-bottom: 40px;
      }

      p {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 36px;
        color: #2C2C2E;
        line-height: 47px;
        text-align: left;
        font-style: normal;
      }

      h5 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 20px;
        color: #FF3B30;
        line-height: 26px;
        text-align: left;
        font-style: normal;
        margin-bottom: -10px;

        em {
          font-size: 32px;
        }
      }

      .buy-paper-btn {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 21px;
        text-align: center;
        font-style: normal;
        width: 200px;
        height: 50px;
        background: #E2291E;
        border-radius: 25px;
        border: none;
        cursor: pointer;
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;

        button {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 21px;
          text-align: center;
          font-style: normal;
          padding: 15px 40px;
          border-radius: 25px;
          margin-right: 12px;
          border: none;
          cursor: pointer;
          background: #E2291E;
        }

        .cart-btn {
          background: #FF9500;
        }

        .buy-pdf-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 6px 6px 6px 60px;

          .svg-icon {
            width: 89px;
            height: 38px;
            padding: 7px 10px;
            background: #2C2C2E;
            border-radius: 19px;
            margin-left: 40px;
          }
        }
        .read-btn{
          text-align: center;
        }
      }








    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #E5E5EA;
    margin: 40px 0;
  }

  .book-info {
    border-bottom: 1px solid #E5E5EA;

    .book-info-item {
      display: flex;
      align-items: center;

      span:first-child {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #2C2C2E;
        line-height: 50px;
        text-align: left;
        font-style: normal;
        background: #F2F2F7;
        width: 180px;
        height: 50px;
        padding-left: 20px;
        border: 1px solid #E5E5EA;
        border-bottom: none;
        border-right: none;
      }

      span:last-child {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #2C2C2E;
        line-height: 50px;
        text-align: left;
        font-style: normal;
        padding-left: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        height: 50px;
        border: 1px solid #E5E5EA;
        border-bottom: none;
      }
    }
  }

  .magazine-details-content {
    margin-bottom: 60px;

    h2 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 24px;
      color: #2C2C2E;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      margin-bottom: 20px;
    }

    .content {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #2C2C2E;
      line-height: 32px;
      text-align: justify;
      font-style: normal;
    }
  }
}

.book-list-container {
  h2 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 24px;
    color: #2C2C2E;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin-bottom: 20px;
  }

  .book-list {
    margin-bottom: 60px;

    .book-item {
      margin-bottom: 20px;
      cursor: pointer;

      img {
        width: 100%;
        height: 240px;
        background: #F2F2F7;
        border-radius: 8px;
        object-fit: contain;
        margin-bottom: 12px;
      }

      .book-info {
        border-bottom: none;

        .book-title {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 18px;
          color: #2C2C2E;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }

        .price-sales {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;

          .price {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #FF3B30;
            line-height: 21px;
            text-align: left;
            font-style: normal;

            em {
              font-size: 24px;

            }
          }

          .sales {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #AEAEB2;
            line-height: 19px;
            text-align: right;
            font-style: normal;
          }
        }
      }

      &:hover {
        .book-title {
          color: #E2291E;
        }
      }
    }
  }
}


@media screen and (max-width: 768px) {
  .book {
    padding-top: 0;

    .line {
      margin: 30px 0;
    }

    .magazine-details {
      margin-top: 0;

      .magazine-details-left {
        width: 100%;
        padding-top: 0;

        .magazine-swiper {
          width: 100%;
          margin-bottom: 0;
          position: relative;
        }

        .magazine-item {
          display: flex;

          img {
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 0;
          }
        }

        .content {
          padding: 40px 50px 40px 0;
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 2.19;
          letter-spacing: 0.8px;
          text-align: left;
          color: #000;
        }
      }

      .magazine-details-right {
        width: 100%;
        margin-left: 0;
        padding: 20px 20px 40px 20px;

        h3 {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #E2291E;
          line-height: 21px;
          text-align: left;
          font-style: normal;
        }

        h5 {
          display: flex;
          // flex-direction: column;
        }

        p {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 24px;
          color: #2C2C2E;
          line-height: 31px;
          text-align: left;
          font-style: normal;
        }

        .btns {
          position: static;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // padding: 10px 20px;
          z-index: 999;

          button {
            width: 49%;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 21px;
            text-align: center;
            font-style: normal;
            // padding: 14px 20px;
            padding: 0;
          }

          .cart-btn {
            width: 34%;
            height: 50px;
          }

          .buy-pdf-btn {
            width: 62%;
            height: 50px;
            padding: 0;
            margin-right: 0;
            padding-left: 25px;
            padding-right: 6px;
            justify-content: space-between;

            .svg-icon {
              margin-left: 0;
            }
          }
          .read-btn{
            width: 100%;
            justify-content: center;
            // padding: 0;
            height: 50px;
          }
        }

        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #636366;
          line-height: 16px;
          text-align: left;
          font-style: normal;

          b {
            color: #000;
          }
        }
      }
    }

    .magazine-details-content {
      margin-bottom: 0;

      h2 {
        border-top: 10px solid #F2F2F7;
        padding: 40px 20px 20px 20px;

      }

      .content {
        padding: 0 20px 40px;
      }
    }

    .book-list-container {
      border-top: 10px solid #F2F2F7;

      h2 {
        padding: 40px 20px 20px 20px;
      }

      .book-list {
        padding: 0 20px;
      }
    }

    .book-info {
      margin: 0 20px 40px;

      .book-info-item {
        span:first-child {
          width: 100px;
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 14px;
          color: #2C2C2E;
          font-style: normal;
          white-space: nowrap;
        }
      }
    }
  }
  .comment-box{
    border-top: 10px solid #F2F2F7;
    padding:  0 20px;
  }
}

.other-news {
  padding: 40px 0 80px;
  margin-top: 100px;
}
</style>
<style>
.el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #FFFFFF;
}


.el-tabs__item {
  font-family: NotoSansCJKTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: left;
  color: #707070;
  /* padding: 8px 15px!important; */
}

.el-tabs__item:hover {
  color: #e13133;
}

.el-tabs__item.is-active {
  font-family: NotoSansCJKTC;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: left;
  color: #e13133;
}

.el-tabs__active-bar {
  height: 4px;
  background: #e13133;
}

.el-tabs__nav-wrap::after {
  bottom: 2px;
  height: 1px;
  background: #e13133;
}

.magazine-swiper .swiper-slide {
  width: 100% !important;
}

.swiper-button-next3 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 9;
}

.swiper-button-next3 .svg-icon,
.swiper-button-prev3 .svg-icon {
  width: 30px;
  height: 30px;
}

.swiper-button-prev3 {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 9;
  transform: rotate(180deg);
}

/* .shopcar-icon {
  position: absolute;
  top: -30px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0px 0px 8px rgb(184, 184, 184);
  display: flex;
  justify-content: center;
  align-items: center;
} */
.shopcar-icon>.num {
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  background: #ffcc33;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 12px;
}

.shopcar-icon>img {
  width: 56px;
  height: 56px;
  vertical-align: middle;
}

.ball {
  position: absolute;
  z-index: 99;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e13133;
  transition: left 0.6s linear, top 0.6s cubic-bezier(0.5, -0.5, 1, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/book-details/index.vue